import { render, staticRenderFns } from "./editReadOnlyItemSwitch.vue?vue&type=template&id=2a50647e&"
import script from "./editReadOnlyItemSwitch.vue?vue&type=script&lang=js&"
export * from "./editReadOnlyItemSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports